module.exports = __webpack_public_path__ + "img/HR13806526186.cdaf34c4.png";